
import {Component, Vue} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';

@Component
export default class FormEducation extends mixins(LoadingMixin, SnackbarMixin) {
  getColor(status: number) {
    return status === 1 ? 'success' : 'error';
  }
  showAddFrom = false;
  form = {
    education_level: null,
    education_name: null,
    education_faculty: null,
    city: null,
    graduationYear: null,
    skill: null,
  };
  listEducation = [];
  listpenyakit = [];
  list_education_level = [];
  listEducationFaculty = [];
  listSkill = [];
  educations = [];
  profileEdit = false;
  isLoading = false;
  items = [
    {
      color: 'primary',
      icon: 'mdi-schoor',
    },
  ];
  get rules() {
    return {
      education_level: 'required',
      education_name: 'required',
      education_faculty: 'required',
      city: 'required',
      graduationYear: 'required',
      skill: 'required',
    };
  }
  async mounted() {
    await this.facthData();
  }
  async deleteItem(item: any) {
    const confirmed = await this.$dialog.delete();

    if (confirmed) {
      try {
        const {message} = await this.$store.dispatch('education/delete', item);
        this.handleSuccess(message);
        this.facthData();
      } catch (e) {
        this.catchError(e);
      }
    }
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('education/getEducation');
      this.finishLoading('detail');

      this.educations = data;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
}
